// extracted by mini-css-extract-plugin
export default {"progressDateContainer":"progressDateContainer-d3SpKoqz"};